const generateUniqueId = () => {
  return Date.now().toString() + Math.random().toString();
};

export default generateUniqueId;
